module.exports = __webpack_public_path__ + "img/printer-red.f0ce3665.svg";